import React from 'react';
import { motion } from 'framer-motion';
import { useSettings } from '../hooks/useSettings';

const FullscreenLoader = () => {
  const { theme } = useSettings();
  const logo = theme?.logo;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-safir-dark via-black to-safir-primary/70 text-white">
      {/* Ambient glows */}
      <div className="absolute -left-20 top-10 w-80 h-80 bg-safir-primary/30 blur-3xl rounded-full" />
      <div className="absolute right-0 -bottom-10 w-96 h-96 bg-safir-secondary/25 blur-3xl rounded-full" />

      <div className="relative flex flex-col items-center gap-6 px-6">
        <motion.div
          className="relative w-28 h-28"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <div className="absolute inset-0 rounded-3xl bg-white/10 backdrop-blur border border-white/15" />
          <div className="absolute inset-2 rounded-2xl bg-black/60 flex items-center justify-center">
            {logo ? (
              <img src={logo} alt="Safir the Elite" className="h-12 w-12 object-contain" />
            ) : (
              <span className="text-xl font-semibold">SE</span>
            )}
          </div>
          <motion.div
            className="absolute inset-0 rounded-3xl border-2 border-safir-secondary/60"
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 2.2, ease: 'linear' }}
          />
        </motion.div>

        <div className="text-center space-y-2">
          <p className="text-2xl font-bold tracking-wide">Safir the Elite</p>
          <p className="text-sm text-gray-200">Preparing your experience...</p>
        </div>

        <div className="flex items-center gap-2 text-gray-200 text-xs uppercase tracking-[0.3em]">
          <motion.span
            className="w-2 h-2 rounded-full bg-safir-secondary"
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut' }}
          />
          <span>Loading</span>
        </div>
      </div>
    </div>
  );
};

export default FullscreenLoader;
